/**
 * GruposConferencia — os três grupos da Conferência (decisão do dono, 2026-09-24).
 *
 *   - ok / provado;
 *   - atividades complementares: o que uma camada precisou de OUTRA e documentou em vez
 *     de fazer (obrigação sem teste, endpoint que o backend não expõe). NÃO são erros —
 *     cor informativa, nunca vermelho/alerta;
 *   - correções pendentes: defeito na própria camada.
 *
 * A classificação é feita pela API (`grupo` em cada item, `porGrupo` na matriz — regra
 * em `navaflow_api/services/classificacao_conferencia.py`). Aqui só se exibe.
 *
 * Standards: Clean, TDD.
 */
import { C } from '@/theme/palette';

export const GRUPO_OK = 'ok';
export const GRUPO_COMPLEMENTAR = 'complementar';
export const GRUPO_CORRECAO = 'correcao';

/** Cor por grupo (getters: acompanham a troca de tema da paleta `C`). */
export const COR_GRUPO = {
  get ok() { return C.cyber; },
  get complementar() { return C.neon; },
  get correcao() { return C.hot; },
};

export const NOTA_COMPLEMENTARES =
  'Atividades complementares não são erros: é o que uma etapa identificou que falta de outra camada — '
  + 'vão no ATIVIDADES-COMPLEMENTARES.md da entrega, para rodar com um agente de IA.';

/** Grupo do item: o que a API mandou; sem ele (resposta antiga), ok ou correção pelo status. */
export function grupoDoItem(item) {
  if (item?.grupo) return item.grupo;
  return item?.status === 'passed' || item?.status === 'ok' ? GRUPO_OK : GRUPO_CORRECAO;
}

/** Contagem por grupo a partir dos itens. */
export function contarGrupos(itens) {
  const out = { ok: 0, complementares: 0, correcoes: 0 };
  for (const it of itens ?? []) {
    const g = grupoDoItem(it);
    if (g === GRUPO_OK) out.ok += 1;
    else if (g === GRUPO_COMPLEMENTAR) out.complementares += 1;
    else out.correcoes += 1;
  }
  return out;
}

function fmt(n) {
  return Number(n ?? 0).toLocaleString('pt-BR');
}

function Chip({ testId, color, children }) {
  return (
    <span data-testid={testId} style={{ fontSize: 11.5, padding: '3px 10px', borderRadius: 6,
      color, background: `${color}1F`, border: `1px solid ${color}55` }}>
      {children}
    </span>
  );
}

/** Três chips: ok, atividades complementares, correções pendentes. */
export function GruposConferencia({ contagem, rotuloOk = 'ok' }) {
  const ok = Number(contagem?.ok ?? 0);
  const compl = Number(contagem?.complementares ?? 0);
  const corr = Number(contagem?.correcoes ?? 0);
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
      <Chip testId="grupo-ok" color={ok > 0 ? COR_GRUPO.ok : C.neutralMuted}>
        {`${fmt(ok)} ${rotuloOk}`}
      </Chip>
      <Chip testId="grupo-complementares" color={compl > 0 ? COR_GRUPO.complementar : C.neutralMuted}>
        {`${fmt(compl)} ${compl === 1 ? 'atividade complementar' : 'atividades complementares'}`}
      </Chip>
      <Chip testId="grupo-correcoes" color={corr > 0 ? COR_GRUPO.correcao : C.neutralMuted}>
        {`${fmt(corr)} ${corr === 1 ? 'correção pendente' : 'correções pendentes'}`}
      </Chip>
    </div>
  );
}

export default GruposConferencia;
